export class TypedEmitter<Events extends { [K in keyof Events]: (...args: never[]) => void }> {
  private listeners = new Map<keyof Events, Set<(...args: never[]) => void>>();

  on<K extends keyof Events>(event: K, callback: Events[K]): () => void {
    const callbacks = this.listeners.get(event) ?? new Set();
    callbacks.add(callback as (...args: never[]) => void);
    this.listeners.set(event, callbacks);
    return () => callbacks.delete(callback as (...args: never[]) => void);
  }

  emit<K extends keyof Events>(event: K, ...args: Parameters<Events[K]>): void {
    for (const callback of this.listeners.get(event) ?? []) {
      callback(...(args as never[]));
    }
  }

  clear(): void {
    this.listeners.clear();
  }
}
